<template>
  <div class="feature--popup">
    <div class="feature--popup--box">
    <div class="feature--popup--label">Space Amenities</div>  
      <CheckboxGroup :values="data" @input="commitValue($event, 'feature_id')"></CheckboxGroup>
    </div>
    <div class="feature--backdrop" @click="$emit('close')"></div>
  </div>
</template>

<script>
import CheckboxGroup from "./CheckboxGroup"

export default {
  name: 'FeaturePopup',
  components: {
    CheckboxGroup
  },
  data: () => ({
  }),
  mounted () {
  },
  props: {
    data: { default: null }
  },
  methods: {
    commitValue (value, field) {
      this.$store.commit(field, value)
    }
  }
}
</script>

<style lang="scss">
@import "../../../scss/global/includes";

.feature--popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1009;
  color: $primary-grey;
}

.feature--popup .group-wrapper {
  display: grid;
  gap: 0 8px;
  grid-template-columns: repeat(2, 1fr);
}

.feature--popup--box {
  width: 50vw;
  max-width: 100%;
  padding: 5vw;
  background: #FFFFFF;
  border-radius: 20px;
  position: fixed;
  top: 50%;
  left: 50%;
  @include transform(translate(-50%, -50%)!important);
  z-index: 1009;
  max-width: none;
  box-shadow: rgba(0,0,0, 0.2) 0 6px 20px;

  @include breakpoint(tablet-landscape) {
    width: 600px;
  }
  @include breakpoint(tablet) {
    padding: 22px;
    width: 90vw;
  }
}

.feature--backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1001;
}

.feature--popup--label {
  @include responsive-text-size('Header--12--BOLD');
  position: absolute;
  top: 2.5vw;
  left: 50%;
  transform: translateX(-50%);
  @include breakpoint(tablet) {
    top: 8px;
  }
}

</style>